import type { TopicThemeInput } from '../../types/sanity'

export interface TopicTheme {
  light: string
  background: string
  promoted: string
  dark: string
  illustration: {
    path: string
    webp?: string
    aspect: number
  }
}

const defaultTheme: TopicTheme = {
  light: '#E8F3FA',
  background: '#D3E8F6',
  promoted: '#B1D6EE',
  dark: '#90C4E6',
  illustration: {
    path: '/illustrations/tenk.png',
    webp: '/illustrations/tenk.webp',
    aspect: 1200 / 1400,
  },
}

export default function getTopic(theme?: TopicThemeInput | null): TopicTheme {
  return theme?.illustration?.path ? (theme as TopicTheme) : defaultTheme
}
